import tiles from "url:../public/16x16_sm.png";
import Colors from "./core/Colors";

const SET_START = 176;
const SET_END = SET_START + 17;

export const TILE_TYPES = {
  EMPTY: String.fromCharCode(SET_START),

  UL_: String.fromCharCode(SET_START),
  U_: String.fromCharCode(SET_START + 2),
  L_: String.fromCharCode(SET_START + 1),

  _L: String.fromCharCode(SET_START + 3),
  _U: String.fromCharCode(SET_START + 4),
  _R: String.fromCharCode(SET_START + 5),
  _D: String.fromCharCode(SET_START + 6),
};

const tileSet = document.createElement("img");
tileSet.src = tiles;

const tileSetPromise = new Promise((r) => (tileSet.onload = r));
const T_SIZE = 16;
const START_C = 32;
const END_C = 126;

const tileMap: Record<string, [number, number]> = {};
//Add Common symbols and alpha numerics
for (let i = START_C; i <= END_C; i++) {
  tileMap[String.fromCharCode(i)] = [
    (i % 16) * T_SIZE,
    Math.floor(i / 16) * T_SIZE,
  ];
}
tileMap[" "] = [0, 0];

for (let i = SET_START; i <= SET_END; i++) {
  tileMap[String.fromCharCode(i)] = [
    (i % 16) * T_SIZE,
    Math.floor(i / 16) * T_SIZE,
  ];
}

export const getTileOptions = async () => {
  await tileSetPromise;
  return {
    layout: "tile-gl",
    tileColorize: true,
    fg: Colors.B_GREY_4,
    bg: Colors.BLACK,
    tileWidth: T_SIZE,
    tileHeight: T_SIZE,
    tileMap,
    tileSet,
  } as const;
};
